import api from '../../common/libs/api.js';
import _ from 'lodash';
import {responseResultValidate} from '@/common/libs/common.js';
const course = {
  state: {
    tabs: {},
    grade: {},
    schoolDefault: {},  //这个暂时没用
    reachBottom: 0,
    conditions: {},  //选择筛选条件时保存以前选的筛选条件
    menuLists: {
      school_default: [],
      school_districts: [],
      search_option: {
        adaptive_object: [],
        course_type: [],
        terms: []
      },
      subject: []
    },  //保存筛选条件
    courseDetailTips: {},  //保存课程详情页的气泡
    courseInfo: {
      school_info: {},
      qq_group_info: {},
      consultant_info: {
        consultant_phone: ''
      },
      feature_msg: [],
      xes_detail: ''
    },   //保存课程详情
    courseTabs: [],  //保存选择中心tab切换信息
    courseBottomInfo: {}, //底部按钮信息
    consults: []
  },
  mutations: {
    addCourseTab(course, preload) {
      course.courseTabs = preload;
    },
    addCourseInfo(state, preload) {
      state.courseInfo = preload;
    },
    addCourseDetailTips (course, preload) {
      course.courseDetailTips = preload;
    },
    addMenuList (course, preload) {
      course.menuLists = preload;
    },
    addConditions (course, preload) {
      course.conditions = preload;
    },
    addTabs (course, preload) {
      course.tabs = preload.tabs;
    },
    getGrade (course, payloade) {
      course.grade = payloade;
    },
    addSchoolDefault (course, preload) {
      course.schoolDefault = preload;
    },
    handleReachBottom (course) {
      course.reachBottom = course.reachBottom + 1;
    },
    getCourseBottomInfo(course, preload) {
      course.courseBottomInfo = JSON.parse(JSON.stringify(preload));
    },
    addConsult(course, preload) {
      course.consults = preload;
    }
  },
  actions: {
    getCourseTab(context, city) {
      let obj = {
        city
      };

      return api.apiMethod.navigation.get(obj).then(res => {
        if (res.data.errid == 0) {
          let list = []
          if (city == '0086') {
            list = res.data.content.list.map(item => {
              let key = item.url_key
              item.url_key = `qt${key.charAt(0).toUpperCase()}${key.slice(1)}`
              return item
            })
          } else {
            list = res.data.content.list
          }
          context.commit('addCourseTab', list);
        } else {
          context.dispatch('toast', {title: res.data.errmsg, show: true});
        }
      });
    },
    getCourseInfo(context, payloade) {
      let query = payloade.query;
      let city = payloade.city;
      let mine = payloade.mine;
      let location = payloade.location;
      let params = payloade.params;
      
      let obj = {
        course_id: params.courseId,
        phone: mine.mobile || '',
        city: city.city_code,
        grade: query.grade || '',
        type: query.type,
        sub_type: query.sub_type,
        version: 99999,
        school_id: query.school_id || '',
        lat: location.lat || city.lat || '',
        lng: location.lng || city.lng || '',
        channel: 'izk_mobile'
      };

      return api.apiMethod.getCourseInfo.post(obj).then(res => {
        console.log('getCourseInfo====:', res.data);
        if (res.data.errid == 0&&res.data.content) {
          if (_.isArray(res.data.content.qq_group_info)) {
            res.data.content.qq_group_info = res.data.content.qq_group_info[0]||{};
          }
          context.commit('addCourseInfo', res.data.content);
          context.commit('setMeta', {
            title: res.data.content.title,
            description: res.data.content.title,
            keywords: res.data.content.share_message||"中考知识点,高考资料,中高考试题"
          })
        } else {
          console.log('获取课程详情异常：', res.data);
          context.dispatch('toast', {title: res.data.errmsg, show: true});
        }
      })
    },
    getCourseDetailTips(context, payloade) {
      return api.apiMethod.bubble.post(payloade).then(res => {
        if (res.data.errid == 0) {
          context.commit('addCourseDetailTips', res.data.content.list);
        } else {
          context.dispatch('toast', {title: res.data.errmsg, show: true});
        }
      })
    },
    getMenuLists(context, payloade) {
      return api.apiMethod.menuList.post(payloade).then(res => {
        if (res.data.errid == 0) {
          context.commit('addMenuList', res.data.content);
        } else {
          context.dispatch('toast', {title: res.data.errmsg, show: true});
        }
      })
    },
    //获取咨询点信息
    getConsultLists(context, payloade) {
      return api.apiMethod.consultPlace.post(payloade).then(res => {
        if (res.data.errid == 0) {
          context.commit('addConsult', res.data.content);
        } else {
          context.dispatch('toast', {title: res.data.errmsg, show: true});
        }
      })
    },
    //获取底部按钮信息
    getCourseBottomInfo(context, payloade) {
      context.commit('isShowLoading', true);
      return api.apiMethod.getCourseBottomInfo.get(payloade.params).then(res => {
        context.commit('isShowLoading', false);
        if (responseResultValidate(res.data, payloade.routerObj)) {
          if (res.data.errcode == 0) {
            context.commit('getCourseBottomInfo', res.data.data);
          } else {
            context.dispatch('toast', {title: res.data.msg, show: true});
          }
        }
      })
    }
  }
};

export default course;



// WEBPACK FOOTER //
// ./src/stores/modules/course.js